import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';
import { addTopOffer } from '@services/shoppingCartService';
import { cartQueryKey } from '@hooks/useCart/useCart';
import type { CartItemDTO, ShoppingCartDTO } from '@t/api.types';

interface UseAddTopOfferOptions {
  onSuccess?: (cart: ShoppingCartDTO) => void;
  onError?: (error: Error) => void;
}

export const useAddTopOffer = (
  sessionId: string,
  { onSuccess, onError }: UseAddTopOfferOptions = {}
): UseMutationResult<ShoppingCartDTO, Error, CartItemDTO> => {
  const queryClient = useQueryClient();
  return useMutation<ShoppingCartDTO, Error, CartItemDTO>({
    mutationFn: (item) => addTopOffer(sessionId, item),
    onSuccess: (cart) => {
      queryClient.setQueryData<ShoppingCartDTO>(cartQueryKey(sessionId), cart);
      onSuccess?.(cart);
    },
    onError,
  });
};
